import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
/*
 * RecoveryData.ts
 */
export class RecoveryData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.matchedNumbers = this.data.getNumberArray(SlingoConstants.PROPERTY_MATCHED_NUMBERS) || [];
            this.stakeAmount = this.data.getNumber(SlingoConstants.PROPERTY_STAKE_AMOUNT);
            this.freeGame = this.data.getBool(SlingoConstants.PROPERTY_IS_FREE_GAME);
        }
    }
    getMatchedNumbers() {
        return this.matchedNumbers.slice();
    }
    getStakeAmount() {
        return this.stakeAmount;
    }
    isFreeGame() {
        return this.freeGame;
    }
}
//# sourceMappingURL=RecoveryData.js.map